(function () {
  "use strict";

  angular.module("sempraWebapp").component("washingPrograms", {
    templateUrl:
      "app/facilityKarcherDetails/washingPrograms/washingPrograms.html",
    controller: washingPrograms,
    bindings: {
      programList: "<",
      activation: "&",
      defaultVisibilityState: "<"
    },
    controllerAs: "vm"
  });

  function washingPrograms($log, $mdDialog, $filter, sortArrayService) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
      if(!vm.programList) {
        return;
      }
      vm.newList = sortArrayService.sortArrayById(
        createSimpleProgramList(vm.programList)
      );
    };

    vm.$onChanges = function (changes) {
      if (changes.programList && changes.programList.currentValue) {
        vm.newList = sortArrayService.sortArrayById(
          createSimpleProgramList(changes.programList.currentValue)
        );
      }
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.updateProgramInfo = function (ev, dataToUpdate, parentId) {
      $mdDialog
        .show({
          controller: "ActuateWashingProgramsController",
          controllerAs: "vm",
          templateUrl:
            "app/karcherCustomDialogs/actuateWashingPrograms/actuateWashingPrograms.html",
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          locals: { data: dataToUpdate, parentId: parentId },
          clickOutsideToClose: false
        })
        .then(
          function (data) {
            vm.activation({ data: data, parentPointId: parentId });
          },
          function () {}
        );
    };

    function createSimpleProgramList(data) {
      return data.reduce(function (total, current) {
        var tempObj = {};
        tempObj.actuators = [];
        tempObj.parentId = current.id;
        tempObj.availability = true;
        for (var j = 0; j < current.feeds.length; j++) {
          if (current.feeds[j].reference === "ID") {
            tempObj.id = parseInt(
              $filter("removeAfterDot")(current.feeds[j].currentValue)
            );
          } else if (current.feeds[j].reference === "AVAILABILITY") {
            tempObj.availability = current.feeds[j].currentValue === "1.0";
          }
        }
        for (var k = 0; k < current.actuators.length; k++) {
          if (current.actuators[k].reference === "PRICE") {
            tempObj.price = current.actuators[k].value;
            tempObj.priceState = current.actuators[k].state;
            tempObj.actuators.push(current.actuators[k]);
          } else if (current.actuators[k].reference === "SPECIAL_OFFER_PRICE") {
            tempObj.soPrice = current.actuators[k].value;
            tempObj.soPriceState = current.actuators[k].state;
            tempObj.actuators.push(current.actuators[k]);
          } else if (current.actuators[k].reference === "NAME") {
            tempObj.name = current.actuators[k].value;
            tempObj.nameState = current.actuators[k].state;
            tempObj.actuators.push(current.actuators[k]);
          } else if (current.actuators[k].reference === "DESCRIPTION") {
            tempObj.description = current.actuators[k].value;
            tempObj.descriptionState = current.actuators[k].state;
            tempObj.actuators.push(current.actuators[k]);
          }
        }

        // Check if tempObj is empty
        if (tempObj.actuators.length !== 0) {
          total.push(tempObj);
        }
        return total;
      }, []);
    }
  }
})();
